/*
 * @Author: your name
 * @Date: 2020-09-28 16:54:51
 * @LastEditTime: 2021-06-24 16:39:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lzxy-homepage\src\commons\bannerModel.ts
 */
export class Banner {
  url: string
  imgUrl: string
  publish: boolean
  constructor (url: string, imgUrl: string, publish: boolean) {
    this.url = url
    this.imgUrl = imgUrl
    this.publish = publish
  }
}

export class Newstitle {
  id: string
  name: string
  constructor (id: string, name: string) {
    this.id = id
    this.name = name
  }
}

export class ProjectSystem {
  pid: string
  projectSystemId: string
  title: string
  poster: string
  constructor (pid: string, projectSystemId: string, title: string, poster: string) {
    this.pid = pid
    this.projectSystemId = projectSystemId
    this.title = title
    this.poster = poster
  }
}
